export default __webpack_public_path__ + "static/media/order_confirmation.2aa6aeac.svg";